<template>
  <div class="w-full max-w-lg mx-auto p-4 sm:py-16">
    <UserActivationForm :activation-url="activationUrl" @user-activated="onUserActivated" />
  </div>
</template>

<script>
import UserActivationForm from 'Components/Users/UserActivationForm.vue';

export default {
  components: {
    UserActivationForm,
  },
  data() {
    return {
      activationUrl: '',
      redirectPath: '/',
    };
  },
  created() {
    this.activationUrl = this.$route.query?.activation_url || '';
    this.redirectPath = this.$route.query?.redirect_path || '/';
  },
  methods: {
    onUserActivated() {
      this.$router.replace(this.redirectPath);
    },
  },
};
</script>
